<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <table class="table service-reminder-table">
                        <thead>
                            <tr>
                                <th class="col-customer">
                                    Customer
                                </th>
                                <th class="col-site">
                                    Site
                                </th>
                                <th class="col-services">
                                    Service
                                </th>
                                <th class="col-contact">
                                    Contact
                                </th>
                                <th class="col-month">
                                    Month
                                </th>
                                <th class="col-status">
                                    Status
                                </th>
                                <th class="col-sent">
                                    Sent
                                </th>
                                <th class="col-notes">
                                    Notes
                                </th>
                                <th class="col-actions">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <row-component
                                v-for="(reminder, i) in reminders"
                                :key="i"
                                :reminder="reminder"
                            />
                            <tr v-if="!loading && !this.reminders.length">
                                <td colspan="7">
                                    No service reminders this month
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import RowComponent from "./RowComponent.vue"

export default {
    components: {
        RowComponent,
    },
    computed: {
        ...mapState('serviceReminders', [
            'reminders',
            'loading',
        ]),
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-reminders/TableComponent.vue